/* MEDIA(2026-09-05): ビルダーを「原価で計算し、お客様が各ショップでパーツを買う」形にする。
   本体（sections/pasotsuku-build-assistant.liquid）は容量上限のため、動きはすべてここに置く。
   本体側の変更は BN_MARKUP=1.0 と入場モーダルの文言、bnBarSync の window.BN_CURRENT/BN_FMT、読み込みタグのみ。

   購入の流れ（専用ページ /pages/buy?id=…&p=N。1画面に1つのことだけ置く）:
     p なし   全体サマリ … 何をいくらで買うのか＋LINE相談＋進め方（自分で組む / 代行2プラン）
     p=1..N   パーツ1点につき1ページ … ショップのリンク →「買えました」で次のパーツへ
     p=N+1    仕上げ … 自分で組む＝LINE組み立て相談 / 代行＝決済
   パーツごとにURLを持たせているので、外のショップから戻っても同じページに着く。

   進行状況は Worker(/plan) に保存する。お客様は同じ端末で続きから戻れ、
   パソツク側は管理パネルの「パーツ購入の進行状況」で見られる。
   保存するのは構成・パーツ・購入済みだけで、氏名や連絡先は送らない。 */
(function () {
  var CFG = window.BN_MEDIA || {};
  var LINE_URL = CFG.line || "https://lin.ee/r5poGTS";
  var AMAZON_TAG = CFG.amazonTag || "";
  var SERVICE_HANDLE = CFG.serviceHandle || "kumitate-daiko";
  var TEL = CFG.tel || "070-3623-8935";
  var MAIL = CFG.mail || "info@pasotsuku.jp";
  var SHIP_TO = CFG.shipTo || "〒299-4502 千葉県いすみ市岬町中原3842 パソツク 組み立て代行係";
  var API = CFG.api || "https://pasotsuku-buyback.tomoyukitakemoto0721.workers.dev";
  var BUY_PATH = CFG.buyPath || "/pages/buy";
  var BUILDER_PATH = CFG.builderPath || "/pages/pc-builder";
  var IS_PAGE = false;/* BUYPAGE(2026-09-06): 専用ページで動いているか */
  var LS = "bnplan1:";
  var LABEL = { cpu: "CPU", gpu: "グラフィックボード", mem: "メモリ", mb: "マザーボード", ssd: "SSD", psu: "電源", case: "ケース", cooler: "CPUクーラー", os: "OS（Windows）" };
  var ORDER = ["cpu", "mb", "mem", "gpu", "ssd", "psu", "case", "cooler"];

  var css =
    /* 追従バー: 販売向けの要素を隠し、価格の意味を変える */
    /* SELLBACK(2026-09-06): 販売に戻したので、送料・分割・保証の表示は隠さない。
       購入パネルは「自分でパーツを買う」を押した人にだけ出す。 */

    /* パネルを開いている間は、流れるカードを止める（後ろで動き続けると読みにくい） */
    ".bnm-open .bnfeed .tr,.bnm-open .pmk .track{animation-play-state:paused!important}" +
    ".bnm-open{overflow:hidden}" +
    /* パネル */
    "#bnm{position:fixed;inset:0;z-index:99998;background:rgba(6,9,16,.62);display:flex;align-items:flex-end;justify-content:center}" +
    "#bnm[hidden]{display:none}" +
    "#bnm .w{width:100%;max-width:760px;max-height:94vh;overflow:auto;background:#fff;border-radius:16px 16px 0 0;padding:0 0 24px;font-family:inherit;color:#16181d;-webkit-overflow-scrolling:touch}" +
    "@media(min-width:800px){#bnm{align-items:center;padding:20px}#bnm .w{border-radius:16px}}" +
    "#bnm .hd{position:sticky;top:0;background:#fff;border-bottom:1px solid #eef0f3;padding:14px 18px 10px;z-index:2}" +
    "#bnm h2{font-size:17px;font-weight:900;margin:0 0 6px;padding-right:40px}" +
    "#bnm .x{position:absolute;top:10px;right:12px;font:inherit;border:1px solid #e2e6ec;background:#fff;border-radius:999px;width:32px;height:32px;cursor:pointer;font-size:17px;line-height:1;color:#16181d}" +
    "#bnm .bar{height:7px;border-radius:999px;background:#eef0f3;overflow:hidden}" +
    "#bnm .bar i{display:block;height:100%;background:#15803d;width:0;transition:width .25s}" +
    "#bnm .barlab{font-size:12px;color:#6b7280;margin-top:5px;display:flex;justify-content:space-between}" +
    "#bnm .barlab b{color:#16181d}" +
    "#bnm .bd{padding:14px 18px 0}" +
    "#bnm .step{margin-bottom:18px}" +
    /* WIZARD(2026-09-06): 上＝いまどの手順か、下＝戻る/次へ */
    "#bnm .steps{display:flex;align-items:center;gap:4px;margin:0 0 9px}" +
    "#bnm .stp{flex:1;display:flex;align-items:center;justify-content:center;gap:6px;background:none;border:0;font:inherit;font-size:11.5px;color:#9aa1ad;cursor:pointer;padding:2px 0}" +
    "#bnm .stp i{font-style:normal;flex:0 0 20px;height:20px;border-radius:999px;background:#eef0f3;color:#6b7280;display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:800}" +
    "#bnm .stp.on{color:#16181d;font-weight:800}#bnm .stp.on i{background:#16181d;color:#fff}" +
    "#bnm .stp.done{color:#15803d}#bnm .stp.done i{background:#15803d;color:#fff}" +
    "#bnm .stp[disabled]{opacity:.4;cursor:default}" +
    /* SCROLLFIX: 進め方が未選択のときに、そこへ目を向けてもらうための点滅 */
    "#bnm .ways.flash{animation:bnmflash 1.1s ease-in-out 2}" +
    "@keyframes bnmflash{0%,100%{box-shadow:0 0 0 0 rgba(22,24,29,0)}50%{box-shadow:0 0 0 5px rgba(22,24,29,.16)}}" +
    "#bnm .ways{border-radius:12px}" +
    "#bnm .steps u{flex:0 0 12px;height:2px;background:#e2e6ec;text-decoration:none}" +
    "#bnm .nav{position:sticky;bottom:0;background:#fff;display:flex;gap:10px;align-items:center;padding:12px 0;border-top:1px solid #eef0f3;margin-top:14px}" +
    "#bnm .nav .btn{margin:0}#bnm .nav .bk{flex:0 0 33%}#bnm .nav .fw{flex:1}" +
    "#bnm .chosen{display:flex;align-items:center;gap:8px;background:#f6f7f9;border:1px solid #e2e6ec;border-radius:10px;padding:8px 11px;margin-bottom:10px;font-size:12.5px;line-height:1.5}" +
    "#bnm .chosen b{font-weight:800}" +
    "#bnm .chosen button{margin-left:auto;flex:0 0 auto;font:inherit;font-size:12px;background:none;border:0;color:#2563eb;text-decoration:underline;cursor:pointer;padding:0}" +
    /* WAYS3: 進め方は3択 */
    "#bnm .way em.pr{display:block;font-style:normal;font-size:15px;font-weight:900;margin-top:8px}" +
    "#bnm .way em.pr small{font-size:11px;font-weight:700;color:#6b7280}" +
    "#bnm .way.on em.pr{color:#16181d}" +
    /* COMEBACK: 外部ショップから戻ってきたときの確認 */
    "#bnm .cameback{border:2px solid #15803d;background:#f2fbf5;border-radius:12px;padding:12px 14px;margin-bottom:12px}" +
    "#bnm .cameback b{display:block;font-size:14px;font-weight:900;margin-bottom:3px}" +
    "#bnm .cameback span{display:block;font-size:12.5px;color:#365243;line-height:1.6}" +
    "#bnm .cameback .cbtn{display:flex;gap:8px;margin-top:10px}#bnm .cameback .btn{flex:1;padding:11px}" +
    /* HELP(2026-09-06): 途中で困ったときの連絡先。どの画面にも出す */
    "#bnm .help{border:1px solid #e2e6ec;border-radius:12px;padding:12px 14px;margin-top:12px;background:#fbfcfd}" +
    "#bnm .help b{display:block;font-size:13px;font-weight:900;margin-bottom:8px}" +
    "#bnm .help .hrow{display:grid;grid-template-columns:1fr;gap:7px;margin-bottom:7px}" +
    "@media(min-width:560px){#bnm .help .hrow{grid-template-columns:1fr 1fr 1fr}}" +
    "#bnm .help .btn{padding:10px;font-size:12.5px}" +
    "#bnm .help span{display:block;font-size:11.5px;color:#6b7280;line-height:1.6}" +
    /* SHIPTOP: パーツを買う画面の先頭に置く送り先 */
    "#bnm .addr.top{margin:0 0 12px}" +
    /* BUYPAGE: 専用ページのときは覆いをやめて、ふつうのカードとして置く */
    "#bnm.page{position:static;inset:auto;background:none;display:block;padding:0;z-index:auto}" +
    "#bnm.page .w{max-width:860px;margin:0 auto;max-height:none;overflow:visible;border-radius:14px;border:1px solid #e6e9ee;box-shadow:0 1px 3px rgba(16,24,40,.06);padding-bottom:20px}" +
    /* ページ版の見出しは貼り付けない。サイト共通の固定ヘッダの裏に隠れて押せなくなるため */
    "#bnm.page .hd{position:static;border-radius:14px 14px 0 0}" +
    "#bnm.page .x{display:none}" +
    /* ページ版では貼り付けない。下まで読んだところに素直に置く方が迷わない */
    "#bnm.page .nav{position:static}" +
    "#bnm .empty{padding:26px 18px;text-align:center}" +
    "#bnm .empty b{display:block;font-size:15px;font-weight:900;margin-bottom:6px}" +
    "#bnm .empty span{display:block;font-size:12.5px;color:#6b7280;line-height:1.7;margin-bottom:14px}" +
    /* SOUDAN: まず相談したい方への入口 */
    "#bnm .soudan{display:block;text-decoration:none;color:#0b3d20;border:2px solid #06c755;background:#f0fbf4;border-radius:12px;padding:13px 15px;margin-bottom:9px}" +
    "#bnm .soudan b{display:block;font-size:14.5px;font-weight:900;margin-bottom:4px;color:#16181d}" +
    "#bnm .soudan span{display:block;font-size:12px;color:#4b5563;line-height:1.6}" +
    "#bnm .soudan em{display:inline-block;font-style:normal;margin-top:9px;background:#06c755;color:#fff;font-size:12.5px;font-weight:800;border-radius:999px;padding:8px 16px}" +
    /* ONEPAGE(2026-09-06): いまどのページか。押せば行き来できる */
    "#bnm .pdots{display:flex;flex-wrap:wrap;gap:4px;margin:0 0 8px}" +
    "#bnm .pd{width:24px;height:24px;border-radius:999px;border:1px solid #e2e6ec;background:#fff;color:#9aa1ad;font:inherit;font-size:11px;font-weight:800;cursor:pointer;padding:0;line-height:1}" +
    "#bnm .pd.on{background:#16181d;border-color:#16181d;color:#fff}" +
    "#bnm .pd.ok{background:#e8f5ec;border-color:#bfe3cc;color:#15803d}" +
    "#bnm .pd.done{color:#4b5563}" +
    /* 全体サマリの一覧 */
    "#bnm .sumlist{list-style:none;margin:0 0 10px;padding:0;border:1px solid #eef0f3;border-radius:12px;overflow:hidden}" +
    "#bnm .sumlist li{display:grid;grid-template-columns:104px 1fr auto;gap:8px;align-items:baseline;padding:9px 12px;border-bottom:1px solid #f2f4f7;font-size:12.5px}" +
    "#bnm .sumlist li:last-child{border-bottom:0}" +
    "#bnm .sumlist .c{color:#6b7280;font-size:11.5px;font-weight:700}" +
    "#bnm .sumlist .c i{display:block;font-style:normal;font-size:10px;font-weight:800;margin-top:2px}" +
    "#bnm .sumlist .n{color:#16181d;line-height:1.5;word-break:break-word}" +
    "#bnm .sumlist .p{font-weight:800;white-space:nowrap}" +
    "#bnm .sumlist li{cursor:pointer;background:#fff;text-align:left;width:100%;border:0;border-bottom:1px solid #f2f4f7;font:inherit}" +
    "#bnm .sumlist li:hover{background:#f8fafc}" +
    "#bnm .sumlist li.ok{background:#f6fbf8}" +
    "#bnm .sumlist .st{font-size:10.5px;font-weight:800;border-radius:999px;padding:2px 8px;white-space:nowrap}" +
    "#bnm .sumlist .st.y{background:#e8f5ec;color:#15803d}" +
    "#bnm .sumlist .st.n{background:#eef0f3;color:#6b7280}" +
    "#bnm .sh.rk{background:#FDE8E8;color:#B01A1A}" +
    "#bnm .sh2{font-size:15px;font-weight:900;margin:0 0 8px}" +
    "#bnm .sumttl{font-size:13px;font-weight:900;color:#4b5563;margin:18px 0 7px}" +
    "#bnm .azcart{border:1px solid #f0b849;background:#fffaf0;border-radius:12px;padding:13px 15px;margin:14px 0 10px}" +
    /* ALT: 売り切れの帯に出す代替案 */
    "#bn-stock .bnalt{display:inline-flex;flex-wrap:wrap;align-items:center;gap:8px;margin-left:10px}" +
    "#bn-stock .bnalt b{font-weight:800}" +
    "#bn-stock .bnalt button{font:inherit;font-size:12px;font-weight:800;border:0;border-radius:999px;padding:6px 14px;background:#fff;color:#b91c1c;cursor:pointer}" +
    "#bn-stock .bnalt button:hover{background:#ffe9e9}" +
    "#bnm .azcart b{display:block;font-size:14px;font-weight:900;margin-bottom:4px}" +
    /* RETURN: 戻り道の案内 */
    "#bnm .ret{border:1px dashed #c8cfd9;border-radius:12px;padding:12px 14px;margin-top:12px;background:#fbfcfd}" +
    "#bnm .ret b{display:block;font-size:13px;font-weight:900;margin-bottom:5px}" +
    "#bnm .ret span{display:block;font-size:11.5px;color:#6b7280;line-height:1.7}" +
    "#bnm .ret .retrow{display:flex;gap:8px;margin:10px 0 6px}#bnm .ret .btn{flex:1;padding:11px;font-size:12.5px}" +
    "#bnm .ret .retnote{font-size:11px;color:#9aa1ad}" +
    /* RETURN: 戻ってきたときに最初に目に入る帯 */
    "#bnm-back{position:fixed;left:0;right:0;bottom:0;z-index:99999;background:#15803d;color:#fff;padding:12px 14px;box-shadow:0 -6px 24px rgba(0,0,0,.25)}" +
    "#bnm-back[hidden]{display:none}" +
    "#bnm-back b{display:block;font-size:13.5px;font-weight:900}" +
    "#bnm-back span{display:block;font-size:11.5px;opacity:.9;margin-top:2px}" +
    "#bnm-back button{margin-top:9px;margin-right:8px;font:inherit;font-size:13px;font-weight:900;border:0;border-radius:8px;padding:10px 18px;background:#fff;color:#15803d;cursor:pointer}" +
    "#bnm-back button.g{background:rgba(255,255,255,.18);color:#fff}" +
    "#bnm .azcart span{display:block;font-size:12px;color:#6b5a3a;line-height:1.65;margin-bottom:10px}" +
    /* パーツ1点のページ */
    "#bnm .one{border:2px solid #16181d;border-radius:14px;padding:16px;margin-bottom:10px}" +
    "#bnm .one.done{border-color:#bfe3cc;background:#f6fbf8}" +
    "#bnm .onum{display:flex;flex-wrap:wrap;align-items:center;gap:6px;font-size:11.5px;font-weight:800;color:#6b7280;margin-bottom:6px}" +
    "#bnm .onum i{font-style:normal}" +
    "#bnm .onm{font-size:17px;font-weight:900;line-height:1.45;margin-bottom:4px;word-break:break-word}" +
    "#bnm .opr{font-size:22px;font-weight:900;margin-bottom:13px}" +
    "#bnm .obought{font-size:14px;font-weight:900;color:#15803d;margin-bottom:10px}" +
    "#bnm .addrline{border:1px solid #f2c94c;background:#fffdf2;border-radius:10px;padding:10px 12px;margin-top:12px}" +
    "#bnm .addrline b{display:block;font-size:12.5px;font-weight:900;margin-bottom:5px}" +
    "#bnm .addrline .ad{display:flex;gap:6px;align-items:center;font-size:12px}" +
    "#bnm .addrline .ad span{flex:1;min-width:0}" +
    "#bnm .addrline .btn{width:auto;flex:none;padding:7px 12px;font-size:11.5px}" +
    "#bnm .sh{display:flex;align-items:center;gap:8px;font-size:15px;font-weight:900;margin:0 0 8px}" +
    "#bnm .sh em{font-style:normal;font-size:11px;font-weight:800;background:#16181d;color:#fff;border-radius:999px;padding:2px 9px;letter-spacing:.04em}" +
    "#bnm .sh small{font-weight:400;font-size:12px;color:#6b7280}" +
    "#bnm .dim{color:#6b7280;font-size:12.5px;line-height:1.6}" +
    /* 進め方 */
    "#bnm .ways{display:grid;grid-template-columns:1fr;gap:8px}" +
    "@media(min-width:640px){#bnm .ways{grid-template-columns:repeat(3,1fr)}}" +
    "#bnm .way{border:2px solid #e2e6ec;border-radius:12px;padding:12px 14px;cursor:pointer;background:#fff;text-align:left;font:inherit}" +
    "#bnm .way.on{border-color:#16181d;background:#f6f7f9}" +
    "#bnm .way b{display:block;font-size:14.5px;font-weight:900;margin-bottom:3px}" +
    "#bnm .way span{display:block;font-size:12px;color:#4b5563;line-height:1.55}" +
    "#bnm .way .tag{display:inline-block;font-size:10.5px;font-weight:800;color:#15803d;background:#e8f5ec;border-radius:999px;padding:1px 7px;margin-top:6px}" +
    /* パーツのステップ */
    "#bnm ol.parts{list-style:none;margin:0;padding:0;counter-reset:s}" +
    "#bnm ol.parts li{position:relative;border:1px solid #e2e6ec;border-radius:12px;padding:11px 12px 11px 44px;margin-bottom:8px;background:#fff}" +
    "#bnm ol.parts li::before{counter-increment:s;content:counter(s);position:absolute;left:12px;top:11px;width:22px;height:22px;border-radius:50%;background:#eef0f3;color:#6b7280;font-size:12px;font-weight:800;display:flex;align-items:center;justify-content:center}" +
    "#bnm ol.parts li.done{background:#f6faf7;border-color:#cfe6d8}" +
    "#bnm ol.parts li.done::before{content:'✓';background:#15803d;color:#fff}" +
    "#bnm ol.parts li.now{border-color:#16181d;box-shadow:0 0 0 3px rgba(22,24,29,.06)}" +
    "#bnm .prow{display:flex;justify-content:space-between;gap:8px;align-items:baseline}" +
    "#bnm .pcat{font-size:11px;font-weight:800;color:#6b7280}" +
    "#bnm .pnm{font-weight:800;font-size:13.5px;line-height:1.35}" +
    "#bnm .ppr{font-weight:900;font-size:13.5px;white-space:nowrap}" +
    "#bnm .lk{display:flex;gap:6px;flex-wrap:wrap;margin-top:7px}" +
    "#bnm .lk a{font-size:12px;font-weight:800;text-decoration:none;border:1px solid #c8cfd9;border-radius:999px;padding:5px 11px;color:#0a63c9;background:#fff}" +
    "#bnm .lk a.new{color:#b45309;border-color:#f3d9b4}" +
    "#bnm .lk button{font:inherit;font-size:12px;font-weight:800;border-radius:999px;padding:5px 13px;cursor:pointer;border:1px solid #16181d;background:#16181d;color:#fff}" +
    /* ショップ表示・在庫バッジ */
    "#bnm .sh{display:inline-block;font-size:10px;font-weight:800;border-radius:999px;padding:1px 6px;margin-left:6px;vertical-align:1px}" +
    "#bnm .sh.dp{background:#e8f0fb;color:#0a63c9}" +
    "#bnm .sh.pt{background:#f0e8fb;color:#6b21a8}" +
    "#bnm .sh.am{background:#fff3e0;color:#b45309}" +
    "#bnm .stk{display:inline-block;font-size:10px;font-weight:800;border-radius:999px;padding:1px 6px;margin-left:6px}" +
    "#bnm .stk.ok{background:#e8f5ec;color:#15803d}" +
    "#bnm .stk.ng{background:#fdecec;color:#b91c1c}" +
    "#bnm .stk.warn{background:#fff3e0;color:#b45309}" +
    /* いま買う1点（大きく出す） */
    "#bnm .focus{border:2px solid #16181d;border-radius:14px;padding:14px;margin-bottom:14px;background:#fff}" +
    "#bnm .focus.fdone{border-color:#cfe6d8;background:#f6faf7;text-align:center;padding:18px}" +
    "#bnm .focus.fdone b{display:block;font-size:15px;font-weight:900;color:#15803d;margin-bottom:4px}" +
    "#bnm .focus.fdone span{font-size:12.5px;color:#4b5563}" +
    "#bnm .fnum{font-size:11.5px;font-weight:800;color:#6b7280;letter-spacing:.04em}" +
    "#bnm .fnm{font-size:17px;font-weight:900;line-height:1.35;margin:3px 0 2px}" +
    "#bnm .fpr{font-size:20px;font-weight:900;margin-bottom:10px}" +
    "#bnm .fgo{display:block;background:#0a63c9;color:#fff;text-decoration:none;border-radius:10px;padding:13px 14px;margin-bottom:8px}" +
    "#bnm .fgo b{display:block;font-size:15px;font-weight:900}" +
    "#bnm .fgo span{display:block;font-size:11.5px;opacity:.85;margin-top:2px;line-height:1.5}" +
    "#bnm .fok{display:block;width:100%;font:inherit;font-size:15px;font-weight:900;background:#15803d;color:#fff;border:none;border-radius:10px;padding:13px;cursor:pointer}" +
    "#bnm .fskip{display:block;width:100%;font:inherit;font-size:12px;font-weight:700;background:none;border:none;color:#6b7280;padding:8px;cursor:pointer;text-decoration:underline}" +
    "#bnm .alltitle{font-size:12px;font-weight:800;color:#6b7280;margin:4px 0 6px}" +
    /* 他の候補 */
    "#bnm .more{font:inherit;font-size:11.5px;font-weight:800;color:#0a63c9;background:none;border:none;padding:6px 0 0;cursor:pointer;display:block}" +
    "#bnm .more b{color:#15803d;margin-left:6px}" +
    "#bnm .cands{margin-top:6px;border-top:1px dashed #e2e6ec;padding-top:6px}" +
    "#bnm .cand{display:flex;align-items:center;gap:6px;padding:5px 0;border-bottom:1px solid #f2f4f7;font-size:12px}" +
    "#bnm .cand:last-of-type{border-bottom:0}" +
    "#bnm .cand .sh{margin-left:0;flex:none}" +
    "#bnm .cand .cn{flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;color:#4b5563}" +
    "#bnm .cand .cp{font-weight:900;white-space:nowrap}" +
    "#bnm .cand a{font-size:11px;font-weight:800;color:#0a63c9;text-decoration:none;border:1px solid #c8cfd9;border-radius:999px;padding:2px 8px;white-space:nowrap}" +
    "#bnm .cand .soon{font-size:10.5px;color:#9aa3b2;white-space:nowrap}" +
    "#bnm .cands .note{font-size:10.5px;color:#9aa3b2;line-height:1.5;margin-top:6px}" +
    "#bnm ol.parts li.done .lk button{background:#fff;color:#15803d;border-color:#cfe6d8}" +
    "#bnm .tot{display:flex;justify-content:space-between;align-items:baseline;font-weight:900;font-size:17px;padding:8px 2px 0;border-top:1px solid #eef0f3;margin-top:4px}" +
    "#bnm .tot small{font-size:11px;color:#6b7280;font-weight:400}" +
    /* 仕上げ */
    "#bnm .fin{border:1px solid #e2e6ec;border-radius:12px;padding:14px}" +
    "#bnm .btn{display:block;width:100%;text-align:center;font:inherit;font-weight:800;font-size:14px;padding:13px;border-radius:10px;border:none;cursor:pointer;text-decoration:none}" +
    "#bnm .btn.line{background:#06c755;color:#fff}" +
    "#bnm .btn.dark{background:#16181d;color:#fff}" +
    "#bnm .btn[disabled]{opacity:.5;cursor:default}" +
    "#bnm .plans{display:grid;grid-template-columns:1fr 1fr;gap:8px;margin:0 0 10px}" +
    "#bnm .plan{border:2px solid #e2e6ec;border-radius:10px;padding:10px;cursor:pointer}" +
    "#bnm .plan.on{border-color:#16181d;background:#f6f7f9}" +
    "#bnm .plan b{display:block;font-size:13px}" +
    "#bnm .plan .pr{font-size:16px;font-weight:900;margin:2px 0}" +
    "#bnm .plan small{display:block;color:#6b7280;font-size:11px;line-height:1.5}" +
    "#bnm .addr{background:#f6f7f9;border-radius:10px;padding:10px 12px;font-size:12.5px;line-height:1.7;margin-top:10px}" +
    "#bnm .addr b{display:block}" +
    "#bnm .addr.big{background:#fff8e6;border:1px solid #f3d9b4}" +
    "#bnm .addr.big b{font-size:13.5px;font-weight:900;color:#8a5a00;margin-bottom:6px}" +
    "#bnm .addr .ad{display:flex;gap:6px;align-items:center;background:#fff;border:1px solid #e2e6ec;border-radius:8px;padding:9px 10px}" +
    "#bnm .addr .ad span{flex:1;min-width:0;font-weight:800;font-size:12.5px;line-height:1.6}" +
    "#bnm .addr .ad .btn{width:auto;flex:none;padding:8px 14px;font-size:12px}" +
    "#bnm .addr .adnote{font-size:11.5px;color:#6b7280;line-height:1.6;margin-top:6px}" +
    "#bnm ol.flow{margin:6px 0 0;padding-left:18px;font-size:12.5px;color:#4b5563;line-height:1.6}" +
    "#bnm .btn.ghost{background:#fff;color:#16181d;border:1px solid #c8cfd9;font-size:12.5px;padding:11px}" +
    "#bnm .share{margin-top:12px;border-top:1px solid #eef0f3;padding-top:10px}" +
    "#bnm .shrow{display:flex;gap:6px}" +
    "#bnm .shrow input{flex:1;min-width:0;font:inherit;font-size:12px;padding:10px;border:1px solid #e2e6ec;border-radius:8px;background:#f6f7f9;color:#4b5563}" +
    "#bnm .shrow .btn{width:auto;flex:none;padding:10px 16px}" +
    "#bnm .wait{background:#fff8e6;border:1px solid #f3d9b4;color:#8a5a00;border-radius:10px;padding:9px 11px;font-size:12.5px;line-height:1.6;margin:0 0 10px}" +
    "#bnm .wait b{font-weight:900}" +
    "#bnm .err{color:#b91c1c;font-size:12.5px;margin-top:6px}" +
    "#bnm .save{font-size:11.5px;color:#6b7280;margin-top:10px;line-height:1.6}";
  var st = document.createElement("style"); st.textContent = css; document.head.appendChild(st);

  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function yen(v) { return "¥" + Math.round(v || 0).toLocaleString("ja-JP"); }
  function track(n, p) { try { if (typeof gtag === "function") gtag("event", n, p || {}); } catch (e) {} }
  function isUsed(name) { return /^\s*中古/.test(String(name || "")); }
  /* SHOPS(2026-09-06): この部品をどこで買うか。URLで決める（名前ではなく実体で判断する） */
  function shopOf(p) {
    var u = String((p && p.url) || "");
    if (/rakuten\.co\.jp|hb\.afl\.rakuten/.test(u)) return { key: "rakuten", name: "楽天市場" };
    if (/dospara\.co\.jp/.test(u)) return { key: "dospara", name: "ドスパラ" };
    if (/amazon\.co\.jp/.test(u)) return { key: "amazon", name: "Amazon" };
    return { key: "amazon", name: "Amazon" };
  }
  /* その部品を買いに行くURL。商品ページが分かっているならそこへ。分からないときだけ検索 */
  function buyUrl(p) {
    var s = shopOf(p);
    if (s.key === "rakuten") return p.url;
    if (s.key === "dospara") return p.url || "";
    return amzUrl(p);
  }
  function asinOf(p) {
    var m = String((p && p.url) || "").match(/\/dp\/([A-Z0-9]{10})/);
    return m ? m[1] : "";
  }
  /* Amazonの一括カート投入。最大10点まで。実機で動作確認済み（確認画面が出る） */
  function amazonCartUrl(parts) {
    var list = parts.filter(function (p) { return !p.bought && asinOf(p); }).slice(0, 10);
    if (list.length < 2) return "";
    var q = list.map(function (p, i) {
      return "ASIN." + (i + 1) + "=" + asinOf(p) + "&Quantity." + (i + 1) + "=1";
    }).join("&");
    return "https://www.amazon.co.jp/associates/addtocart?" +
      (AMAZON_TAG ? "AssociateTag=" + encodeURIComponent(AMAZON_TAG) + "&" : "") + q;
  }
  function q(name) { return String(name || "").replace(/^\s*中古\s*/, "").replace(/\s+\d{6,}\s*$/, "").replace(/\([^)]*\)/g, " ").replace(/【[^】]*】/g, " ").replace(/\s{2,}/g, " ").trim().slice(0, 60); }
  /* 本体は即時関数の中なので、bnBarSync が window.BN_FMT / window.BN_CURRENT に出したものを使う */
  /* ALT: 代わりの候補を短い名前で見せる */
  function dispOf(cat, p) { try { return displayName(cat, p); } catch (e) { return String(p.name || "").slice(0, 40); } }
  function displayName(k, p) {
    var F = window.BN_FMT || {};
    try {
      if (k === "cpu" && F.cpu) return F.cpu(p.name).replace(/\s*\[[^\]]*\]\s*$/, "");
      if (k === "gpu" && F.gpu) return F.gpu(p.name);
      if (k === "mem" && F.mem) return F.mem(p.name, p.gb);
      if (k === "ssd" && F.ssd) return F.ssd(p.name);
      if (F.clean) return F.clean(p.name);
    } catch (e) {}
    return q(p.name);
  }

  /* ---------- 状態 ---------- */
  var S = { parts: [], mode: "", id: null, planKey: "", total: 0, plans: null, plan: null, busy: false, offers: {}, stock: {}, openCat: "", os: null, pg: 0, planIdx: 0, awaiting: "", subs: {} };

  /* OS（Windows 11 Home の正規品）。価格とリンクは毎日Amazonから取り込んだものを使う */
  function loadOs() {
    return fetch(API + "/market/os.json", { cache: "default" }).then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { if (j && j.ok && j.os) S.os = j.os; }).catch(function () {});
  }

  /* 同じ規格の候補をまとめて取る（D1だけなので速い）。1回のリクエストで構成ぶん */
  function loadOffers() {
    /* AMAZONONLY(2026-09-06): ケースとOSはAmazonの新品なので、ドスパラの在庫記録から候補は作れない */
    var body = { parts: S.parts.filter(function (p) { return p.cat !== "case" && p.cat !== "os"; })
      .map(function (p) { return { cat: p.cat, name: p.name }; }) };
    return fetch(API + "/market/offers", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (!j || !j.ok) return;
        S.offers = {};
        (j.parts || []).forEach(function (o) { S.offers[o.cat] = o; });
        if (document.getElementById("bnm-body")) render();
      }).catch(function () {});
  }
  function sig() { return S.parts.map(function (p) { return p.cat + ":" + p.name; }).join("|"); }
  function hash(s) { var h = 5381; for (var i = 0; i < s.length; i++) h = ((h * 33) ^ s.charCodeAt(i)) >>> 0; return h.toString(36); }
  /* BUYPAGE: ビルダーと購入ページで同じ続きを見るため、プランIDがあればそれを鍵にする */
  function lsGet() { return (S.id ? lsRead(S.id) : null) || lsRead(S.planKey); }
  /* COMEBACK: 外部ショップから戻る途中で再読み込みされても続きから出せるよう、構成そのものも残す */
  function lsSet() {
    try {
      var rec = JSON.stringify({
        id: S.id, mode: S.mode, planIdx: S.planIdx, pg: S.pg, awaiting: S.awaiting, total: S.total,
        parts: S.parts.map(function (p) { return { cat: p.cat, name: p.name, disp: p.disp, price: p.price, url: p.url, used: p.used, bought: !!p.bought }; }),
        bought: S.parts.filter(function (p) { return p.bought; }).map(function (p) { return p.cat; }),
      });
      localStorage.setItem(LS + S.planKey, rec);
      if (S.id) localStorage.setItem(LS + S.id, rec);
      localStorage.setItem(LS + "last", S.id || S.planKey);
    } catch (e) {}
  }
  function lsLast() { try { return localStorage.getItem(LS + "last") || ""; } catch (e) { return ""; } }
  function lsRead(k) { try { return JSON.parse(localStorage.getItem(LS + k) || "null"); } catch (e) { return null; } }
  function openFlag(v) { try { if (v) sessionStorage.setItem("bnm:open", "1"); else sessionStorage.removeItem("bnm:open"); } catch (e) {} }
  function wasOpen() { try { return sessionStorage.getItem("bnm:open") === "1"; } catch (e) { return false; } }

  var saveTimer = null;
  function save() {
    lsSet();
    clearTimeout(saveTimer);
    saveTimer = setTimeout(function () {
      var body = {
        id: S.id || undefined, mode: S.mode || "undecided", spec: specText(),
        parts: S.parts.map(function (p) { return { cat: p.cat, name: p.disp, price: p.price, url: p.url, used: p.used, bought: !!p.bought }; }),
      };
      fetch(API + "/plan", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) })
        .then(function (r) { return r.json(); })
        .then(function (j) { if (j && j.ok && j.id) { S.id = j.id; lsSet(); } })
        .catch(function () { /* 通信できなくても、この端末の記録は残る */ });
    }, 600);
  }
  /* BUYPAGE: 購入ページへ移る前に1回だけ確実に保存する。IDが返ればURLに載せられる */
  function saveNow() {
    var body = {
      id: S.id || undefined, mode: S.mode || "undecided", spec: specText(),
      parts: S.parts.map(function (p) { return { cat: p.cat, name: p.disp, price: p.price, url: p.url, used: p.used, bought: !!p.bought }; }),
    };
    var req = fetch(API + "/plan", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (j) { if (j && j.ok && j.id) { S.id = j.id; lsSet(); } })
      .catch(function () {});
    /* 通信が遅くても待たせない。IDが無くてもこの端末の記録から復元できる */
    return Promise.race([req, new Promise(function (ok) { setTimeout(ok, 2500); })]);
  }
  function specText() {
    return S.parts.map(function (p) { return LABEL[p.cat] + ":" + p.disp; }).join(" / ").slice(0, 480);
  }

  /* ---------- 部品 ---------- */
  /* 商品ページが決まっているもの（OS・Amazonのケース）は、検索ではなくその商品へ直接 */
  function amzUrl(p) {
    if (p.url && /amazon\.co\.jp/.test(p.url)) return p.url + (AMAZON_TAG ? (p.url.indexOf("?") >= 0 ? "&" : "?") + "tag=" + encodeURIComponent(AMAZON_TAG) : "");
    return "https://www.amazon.co.jp/s?k=" + encodeURIComponent(q(p.name)) + (AMAZON_TAG ? "&tag=" + encodeURIComponent(AMAZON_TAG) : "");
  }
  /* 同じ規格の他の候補（価格コムのような並び）。ドスパラの在庫記録から作る */
  /* いま買う1点だけを大きく出す。「開く → 買う → 戻って押す」を1往復ずつ繰り返す形 */
  function candsHtml(o) {
    return '<div class="cands">' + (o.offers || []).map(function (x) {
      var tag = x.shop === "pasotsuku" ? '<span class="sh pt">パソツク</span>' : '<span class="sh dp">ドスパラ</span>';
      var nm = esc(String(x.name).replace(/^\s*中古\s*/, "").replace(/\s+\d{6,}\s*$/, "")).slice(0, 64);
      return '<div class="cand">' + tag + '<span class="cn">' + nm + "</span><span class=\"cp\">" + yen(x.price) + "</span>" +
        (x.url ? '<a href="' + esc(x.url) + '" target="_blank" rel="noopener" data-shop="dospara">見る</a>' : '<span class="soon">近日</span>') + "</div>";
    }).join("") + '<div class="note">価格は記録時点のものです。パソツクの中古パーツもここに並びます（現在は在庫がありません）。</div></div>';
  }
  /* SHIPTOP(2026-09-06): 代行のときの送り先。各ショップの注文画面で指定していただくものなので、
     「パーツを買う」画面の一番上にも出す。 */
  function addrHtml(top) {
    return '<div class="addr big' + (top ? " top" : "") + '"><b>買ったパーツは、この住所へお送りください</b>' +
      '<div class="ad"><span id="bnm-addr">' + esc(SHIP_TO) + '</span><button type="button" class="btn ghost" id="bnm-addrcopy">コピー</button></div>' +
      '<div class="adnote">各ショップの注文時に、お届け先をこの住所に指定していただくのがいちばん確実です（そのまま当店に届きます）。ご自宅で受け取ってから転送していただいても構いません。送料はお客様のご負担です。</div></div>';
  }
  /* HELP(2026-09-06): 買い方が分からない・パーツが売り切れていた等、途中で止まったときの窓口。
     外のショップを行き来する作りなので、どの画面からでも同じ場所に出しておく。 */
  function helpHtml() {
    var sub = encodeURIComponent("PCビルダーの構成について");
    var body = encodeURIComponent("（ご質問をこちらにご記入ください）\n\n----\n" +
      (S.id ? "進行状況ID: " + S.id + "\n" : "") + "構成: " + specText());
    return '<div class="help"><b>途中で分からないこと・困ったことがあればご連絡ください</b>' +
      '<div class="hrow">' +
      '<a class="btn line" href="' + esc(LINE_URL) + '" target="_blank" rel="noopener" data-help="line">LINEで相談する</a>' +
      '<a class="btn ghost" href="tel:' + esc(TEL.replace(/-/g, "")) + '" data-help="tel">お電話 ' + esc(TEL) + "</a>" +
      '<a class="btn ghost" href="mailto:' + esc(MAIL) + "?subject=" + sub + "&body=" + body + '" data-help="mail">メールで質問</a>' +
      "</div>" +
      "<span>パーツが売り切れていた・どれを選べばいいか分からない・組み立てで手が止まった、どんなことでも大丈夫です。ご連絡いただければ、こちらで代わりの候補をお探しします。</span></div>";
  }
  function finHtml() {
    if (S.mode === "self") {
      return '<div class="fin"><div class="dim" style="margin-bottom:10px">パーツが届いたら、LINEで組み立て相談ができます。配線・BIOS・OSインストールなど、写真を送っていただきながら一緒に進めます。相談は無料です。</div>' +
        '<a class="btn line" href="' + esc(LINE_URL) + '" target="_blank" rel="noopener" data-path="self">LINEで組み立て相談</a></div>';
    }
    if (S.mode === "daiko") {
      var left = S.parts.filter(function (p) { return !p.bought; }).length;
      return '<div class="fin"><div class="dim" style="margin-bottom:10px">買ったパーツを下記へお送りください。パソツクが組み立て・動作確認を行い、ご指定の住所へ納品します。納品後は、購入店のパーツ保証期間において動作を保証します。商品到着後の初期不良と、パーツ保証期間内のパーツ交換サポートに対応いたします。' + (S.planIdx === 1 ? "フルサポートプランなので、組み立て後もLINE・お電話で手厚くご相談いただけます。" : "") + '</div>' +
        '<div class="chosen"><span>お申し込みプラン：<b>' + esc(S.plan ? S.plan.title + "　" + yen(S.plan.price) : "読み込み中…") + '</b></span><button type="button" data-go="1">変更</button></div>' +
        (left ? '<div class="wait">パーツをすべて購入してから、このサポートをご購入ください。<b>残り ' + left + " 点</b>（上の丸数字から、まだのパーツへ移動できます）</div>" : "") +
        '<button class="btn dark" type="button" id="bnm-go"' + (left ? " disabled" : "") + ">" + (left ? "パーツの購入後に申し込めます" : "組み立てサポートを購入する") + "</button>" +
        '<div class="err" id="bnm-err"></div>' +
        '<div class="share"><div class="dim" style="margin-bottom:5px">あとで購入する・LINEで送る場合はこのリンクをどうぞ。開くとこの構成の情報つきでカートに入ります。</div>' +
        '<div class="shrow"><input id="bnm-link" readonly value="' + esc(permalink()) + '"><button class="btn ghost" type="button" id="bnm-copy">コピー</button></div></div>' +
        addrHtml(false).replace("</div></div>", "</div>") +
        '<ol class="flow"><li>各ショップでパーツを買う</li><li>組み立てサポートを購入（決済）</li><li>パーツが当店（いすみ市）に届く</li><li>組立・OSインストール・動作検証</li><li>ご注文の住所へ返送（送料込み）</li></ol></div></div>';
    }
    return '<div class="fin dim">上で進め方を選ぶと、ここに次の手順が出ます。</div>';
  }
  /* WIZARD(2026-09-06): 1画面に1手順だけ出す */
  function planPrice(i, d) { return (S.plans && S.plans[i]) ? S.plans[i].price : d; }
  function modeLabel() {
    if (S.mode === "self") return "自分で組み立てる（無料・LINE相談つき）";
    if (S.mode === "daiko") return (S.planIdx === 1 ? "パソツクにお任せ＋フルサポート" : "パソツクが組み立て・動作確認・納品") +
      "（" + yen(planPrice(S.planIdx, S.planIdx === 1 ? 19800 : 13800)) + "）";
    return "";
  }
  /* WAYS3: 1ページ目の3択。代行は2プランをここで選んでいただく */
  function waysHtml() {
    var on = function (m, i) { return (S.mode === m && (m !== "daiko" || S.planIdx === i)) ? " on" : ""; };
    return '<div class="ways">' +
      '<button type="button" class="way' + on("self") + '" data-mode="self">' +
        "<b>自分で組み立てる</b>" +
        "<span>パーツをご自宅宛てに購入してください。</span>" +
        "<span>LINEにて自作で困った際の相談等を承ります。</span>" +
        '<em class="pr">無料</em></button>' +
      '<button type="button" class="way' + on("daiko", 0) + '" data-mode="daiko" data-plan="0">' +
        "<b>パソツクに組み立て・動作確認・納品してもらう</b>" +
        "<span>パソツクが組み立て・動作確認を代行します。納品後、購入店のパーツ保証期間において動作を保証します。</span>" +
        "<span>商品到着後の初期不良と、パーツ保証期間のパーツ交換サポートのみ対応いたします。</span>" +
        '<em class="pr">' + yen(planPrice(0, 13800)) + "<small> 税込</small></em></button>" +
      '<button type="button" class="way' + on("daiko", 1) + '" data-mode="daiko" data-plan="1">' +
        "<b>組み立て・動作確認・納品＋フルサポートプラン</b>" +
        '<span class="tag">初心者におすすめ</span>' +
        "<span>上の内容に加えて、組み立て後もLINE・お電話で手厚くサポートいたします。</span>" +
        '<em class="pr">' + yen(planPrice(1, 19800)) + "<small> 税込</small></em></button>" +
    "</div>";
  }
  /* SOUDAN(2026-09-06): 「これで合ってる？」の段階で止まってしまう方が多いので、
     手順の一番上に相談の入口を置く。構成のリンクを一緒にコピーできるようにしておく。 */
  function buildUrl() { return location.origin + BUY_PATH + (S.id ? "?id=" + encodeURIComponent(S.id) : ""); }
  function soudanHtml() {
    return '<a class="soudan" href="' + esc(LINE_URL) + '" target="_blank" rel="noopener" data-help="soudan">' +
      "<b>まず、この構成をパソツクに相談する</b>" +
      "<span>「これで大丈夫？」「もっと安くならない？」「このゲームは動く？」——中古パーツを毎日見ている店主がお答えします。ご相談は無料です。</span>" +
      "<em>LINEで相談する</em></a>" +
      '<div class="shrow" style="margin:0 0 14px"><input id="bnm-blink" readonly value="' + esc(buildUrl()) + '">' +
      '<button class="btn ghost" type="button" id="bnm-bcopy">リンクをコピー</button></div>' +
      '<div class="dim" style="margin:-8px 0 14px">↑ この構成のリンクです。LINEに貼って送っていただくと、こちらで中身を見ながらお答えできます。</div>';
  }
  /* ONEPAGE(2026-09-06): ページの並びは 0=全体サマリ / 1..N=パーツ1点ずつ / N+1=仕上げ */
  function pgCount() { return S.parts.length + 2; }
  function pgKind(n) { return n <= 0 ? "summary" : (n > S.parts.length ? "finish" : "part"); }
  function pgPart(n) { return S.parts[n - 1] || null; }
  function pgResume() {
    if (!S.mode) return 0;
    var i = S.parts.findIndex(function (p) { return !p.bought; });
    return i < 0 ? S.parts.length + 1 : i + 1;
  }
  /* PGURL(2026-09-06): パーツ1点ごとにURLを持たせる。
     ショップのタブから戻ってきたときも、ブラウザの「戻る」でも、同じパーツのページに着く。 */
  function pgUrl(n) {
    var qs = [];
    if (S.id) qs.push("id=" + encodeURIComponent(S.id));
    if (n > 0) qs.push("p=" + n);
    return BUY_PATH + (qs.length ? "?" + qs.join("&") : "");
  }
  function pgFromUrl() {
    try {
      var v = new URLSearchParams(location.search).get("p");
      if (v == null) return null;
      var n = parseInt(v, 10);
      return isNaN(n) ? null : n;
    } catch (e) { return null; }
  }
  function pgPush(n) { if (IS_PAGE) { try { history.pushState({ pg: n }, "", pgUrl(n)); } catch (e) {} } }
  function pgReplace(n) { if (IS_PAGE) { try { history.replaceState({ pg: n }, "", pgUrl(n)); } catch (e) {} } }
  window.addEventListener("popstate", function () {
    if (!IS_PAGE || !panel || !S.parts.length) return;
    var n = pgFromUrl();
    if (n == null) n = 0;
    S.pg = Math.max(0, Math.min(n, pgCount() - 1));
    render();
  });
  /* 進め方が未選択のまま先へ進もうとしたら、選ぶ場所まで連れていく（黙って何もしないのは避ける） */
  function needWays() {
    var el = panel && panel.querySelector(".ways");
    if (!el) return;
    try { el.scrollIntoView({ block: "center", behavior: "smooth" }); } catch (e) { el.scrollIntoView(); }
    el.classList.remove("flash");
    void el.offsetWidth;
    el.classList.add("flash");
  }
  /* RETURN(2026-09-06): スマホで戻ってくるための道。押した直後に出す */
  function isPhone() { try { return window.matchMedia("(max-width: 820px)").matches; } catch (e) { return false; } }
  /* RETURN: 戻り先は「いま見ているパーツのページ」。全体サマリではなく、その1点に戻す */
  function backUrl() { return IS_PAGE ? location.origin + pgUrl(S.pg) : buildUrl(); }
  function lineShareUrl() {
    var p = pgKind(S.pg) === "part" ? pgPart(S.pg) : null;
    var t = "【パソツク】パーツの買い方\n" +
      (p ? "いま買うパーツ: " + LABEL[p.cat] + " " + p.disp + "\n" : "") +
      "続きはこちら\n" + backUrl();
    return "https://line.me/R/msg/text/?" + encodeURIComponent(t);
  }
  function returnHtml() {
    return '<div class="ret"><b>お店から戻ってくる道を用意しておきましょう</b>' +
      "<span>お店のページは新しいタブで開きます。スマホだと買い終わったあとに" +
      "この画面を見失いやすいので、先にこのページのリンクを手元に残しておくと確実です。</span>" +
      '<div class="retrow">' +
      '<a class="btn line" href="' + esc(lineShareUrl()) + '" target="_blank" rel="noopener" data-ret="line">LINEに送っておく</a>' +
      '<button type="button" class="btn ghost" data-ret="copy">リンクをコピー</button>' +
      "</div>" +
      '<span class="retnote">送ったリンクを開くと、いまのパーツの画面がそのまま出ます。</span></div>';
  }
  function goPg(n) {
    if (n < 0) n = 0;
    if (n > pgCount() - 1) n = pgCount() - 1;
    /* お届け先が変わるので、進め方だけは先に決めていただく */
    if (n > 0 && !S.mode) { if (S.pg !== 0) { S.pg = 0; render(); } needWays(); return; }
    if (n === S.pg) return;
    S.pg = n; S.awaiting = ""; lsSet(); pgPush(n);
    track("bn_media_page", { pg: n, kind: pgKind(n), mode: S.mode || "" });
    render();
  }
  function dotsHtml() {
    var out = '<div class="pdots"><button type="button" class="pd' + (S.pg === 0 ? " on" : " done") + '" data-go="0" title="全体">≡</button>';
    S.parts.forEach(function (p, i) {
      var n = i + 1;
      out += '<button type="button" class="pd' + (S.pg === n ? " on" : (p.bought ? " ok" : "")) + '" data-go="' + n + '" title="' + esc(LABEL[p.cat]) + '">' + (p.bought ? "✓" : n) + "</button>";
    });
    var f = S.parts.length + 1;
    return out + '<button type="button" class="pd' + (S.pg === f ? " on" : "") + '" data-go="' + f + '" title="仕上げ">★</button></div>';
  }
  function headTitle() {
    var k = pgKind(S.pg);
    if (k === "summary") return "この構成の買い方";
    if (k === "finish") return S.mode === "self" ? "組み立てる" : "組み立て代行を申し込む";
    var p = pgPart(S.pg);
    return p ? LABEL[p.cat] + "を買う" : "パーツを買う";
  }
  /* ① 全体サマリ: 何をいくらで買うのか。それだけ。 */
  function summaryHtml() {
    /* PGURL: 1行がそのパーツのページへの入口。どれが済んでどれが残っているかを一覧で見せる */
    var rows = S.parts.map(function (p, i) {
      return '<li class="' + (p.bought ? "ok" : "") + '" data-go="' + (i + 1) + '" role="button" tabindex="0">' +
        '<span class="c">' + esc(LABEL[p.cat]) +
        (function (s2) { return '<i class="sh ' + (s2.key === "dospara" ? "dp" : s2.key === "rakuten" ? "rk" : "am") + '">' + esc(s2.name) + "</i>"; })(shopOf(p)) + "</span>" +
        '<span class="n">' + esc(p.disp) + "</span>" +
        '<span class="p">' + yen(p.price) +
        (S.mode ? '<br><span class="st ' + (p.bought ? "y" : "n") + '">' + (p.bought ? "購入済み ✓" : "これから") + "</span>" : "") +
        "</span></li>";
    }).join("");
    /* WAYSFIRST(2026-09-06): いちばん上は進め方の選択。
       ここでお届け先（ご自宅 / 当店）が変わるので、パーツを買い始める前に決めていただく。 */
    return '<div class="step">' +
      '<div class="sh2">まず、進め方をお選びください</div>' +
      '<div class="dim" style="margin:-4px 0 10px">買っていただくパーツはどちらを選んでも同じです。組み立てと動作確認をご自身でされるか、パソツクにお任せいただくかの違いです。</div>' +
      waysHtml() +
      '<div class="sumttl">この構成で買うパーツ（' + S.parts.length + "点）</div>" +
      '<ul class="sumlist">' + rows + "</ul>" +
      '<div class="tot"><span>パーツ合計（目安・税込）</span><span>' + yen(S.total) + "</span></div>" +
      '<div class="dim" style="margin:8px 0 16px">このあと1点ずつ、順番にご購入いただきます。価格は各ショップの相場（目安）で、実際の在庫と価格はリンク先が最新です。</div>' +
      amazonCartHtml() + soudanHtml() + "</div>";
  }
  /* SHOPS: Amazonのパーツをまとめてカートに入れる案内。2点以上あるときだけ出す */
  function amazonCartHtml() {
    /* 新品ビルダーだけに出す。中古はドスパラが中心で、まとめて入れられるのはケースとOSくらいなので出さない。
       新品ページには window.BN_NEW_API が定義されている（生成元のsectionが入れている）。 */
    if (!window.BN_NEW_API) return "";
    var url = amazonCartUrl(S.parts);
    if (!url) return "";
    var n = S.parts.filter(function (p) { return !p.bought && asinOf(p); }).length;
    return '<div class="azcart"><b>Amazonのパーツは、まとめてカートに入れられます</b>' +
      "<span>この構成のうち Amazon で買う " + Math.min(n, 10) + "点を一度にカートへ入れます。" +
      "押すと確認画面が出るので、そこで内容を確かめてから入れてください。" +
      (n > 10 ? "（一度に入れられるのは10点までです）" : "") + "</span>" +
      '<a class="btn dark" href="' + esc(url) + '" target="_blank" rel="noopener sponsored" data-shop="amazon-cart">Amazonのパーツをまとめてカートに入れる</a></div>';
  }

  /* ② パーツ1点のページ。買うのは1つだけ、というのが一目で分かる形にする */
  function partHtml(n) {
    var p = pgPart(n); if (!p) return "";
    var o = S.offers[p.cat], st = S.stock[p.cat];
    var cheaper = o && o.min != null && o.min < p.price;
    var sh = shopOf(p);
    var shop = sh.name;
    var href = buyUrl(p);
    var stk = st === "gone" ? '<span class="stk ng">売り切れ</span>'
      : st === "price" ? '<span class="stk warn">価格が変わりました</span>'
      : (st && st !== "skip" && st !== "unknown") ? '<span class="stk ok">在庫あり</span>' : "";
    return '<div class="step">' + ((S.awaiting === p.cat && !p.bought) ? comebackHtml() : "") +
      '<div class="one' + (p.bought ? " done" : "") + '">' +
        '<div class="onum">' + n + " / " + S.parts.length + "　" + esc(LABEL[p.cat]) +
          '<i class="sh ' + (sh.key === "dospara" ? "dp" : sh.key === "rakuten" ? "rk" : "am") + '">' + esc(sh.name) + "</i>" + stk + "</div>" +
        '<div class="onm">' + esc(p.disp) + "</div>" +
        '<div class="opr">' + yen(p.price) + "</div>" +
        (p.bought
          ? '<div class="obought">購入済みです ✓</div><button type="button" class="btn ghost" data-buy="' + p.cat + '">やっぱりまだ買っていない</button>'
          : '<a class="fgo" href="' + esc(href) + '" target="_blank" rel="noopener" data-shop="' + (p.used ? "dospara" : "amazon") + '" data-cat="' + p.cat + '"><b>' + shop + "で開いて買う</b><span>新しいタブで開きます。買い終わったらこの画面に戻ってください</span></a>" +
            '<button type="button" class="fok" data-buy="' + p.cat + '">買えました → 次のパーツへ</button>') +
      "</div>" +
      (o && o.n > 1 ? '<button type="button" class="more" data-more="' + p.cat + '">' +
        (S.openCat === p.cat ? "候補を閉じる" : "同じ規格の他の候補 " + o.n + "件") +
        (cheaper ? '<b>最安 ' + yen(o.min) + "</b>" : "") + "</button>" : "") +
      (S.openCat === p.cat && o ? candsHtml(o) : "") +
      (S.mode === "daiko" ? addrLine()
        : '<div class="dim" style="margin-top:12px">お届け先はご自宅をご指定ください。</div>') +
      (p.bought ? "" : returnHtml()) + "</div>";
  }
  /* 代行のときの送り先。パーツのページでは1行にまとめて置く */
  function addrLine() {
    return '<div class="addrline"><b>お届け先は、この住所（当店）をご指定ください</b>' +
      '<div class="ad"><span id="bnm-addr">' + esc(SHIP_TO) + '</span>' +
      '<button type="button" class="btn ghost" id="bnm-addrcopy">コピー</button></div></div>';
  }
  function navHtml() {
    var last = pgCount() - 1;
    var back = S.pg > 0 ? '<button type="button" class="btn ghost bk" data-go="prev">← 戻る</button>' : "";
    var fw;
    if (S.pg === 0) {
      fw = '<button type="button" class="btn dark fw" data-go="next">' +
        (S.mode ? "次へ：1つ目のパーツを買う →" : "進め方を選んで次へ →") + "</button>";
    } else if (S.pg < last) {
      var p = pgPart(S.pg);
      fw = '<button type="button" class="btn ' + (p && p.bought ? "dark" : "ghost") + ' fw" data-go="next">' +
        (S.pg === last - 1 ? "次へ：仕上げ →" : (p && p.bought ? "次のパーツへ →" : "あとにして次へ →")) + "</button>";
    } else {
      fw = '<button type="button" class="btn ghost fw" data-go="close">' + (IS_PAGE ? "ビルダーに戻る" : "閉じる") + "</button>";
    }
    return '<div class="nav">' + back + fw + "</div>";
  }
  function chosenHtml() {
    if (!S.mode) return "";
    return '<div class="chosen"><span>進め方：<b>' + esc(modeLabel()) + "</b></span>" +
      '<button type="button" data-go="0">変更</button></div>';
  }
  /* COMEBACK: ショップのタブから戻ってきた直後に、その1点だけを大きく聞く */
  function comebackHtml() {
    if (!S.awaiting) return "";
    var p = S.parts.filter(function (x) { return x.cat === S.awaiting; })[0];
    if (!p || p.bought) return "";
    return '<div class="cameback"><b>おかえりなさい</b>' +
      "<span>" + esc(LABEL[p.cat]) + "「" + esc(p.disp) + "」のページを開きました。ご購入できましたか？</span>" +
      '<div class="cbtn"><button type="button" class="btn dark" data-cb="yes">はい、買えました</button>' +
      '<button type="button" class="btn ghost" data-cb="no">まだ／あとにする</button></div></div>';
  }
  function render() {
    var el = document.getElementById("bnm-body");
    if (!el) return;
    if (S.pg == null) S.pg = 0;
    if (S.pg > pgCount() - 1) S.pg = pgCount() - 1;
    var done = S.parts.filter(function (p) { return p.bought; }).length;
    var k = pgKind(S.pg);
    var h2 = panel && panel.querySelector(".hd h2"); if (h2) h2.textContent = headTitle();
    var sw = document.getElementById("bnm-steps"); if (sw) sw.innerHTML = dotsHtml();
    var bw = document.getElementById("bnm-barwrap"); if (bw) bw.hidden = (k === "summary");
    document.getElementById("bnm-fill").style.width = (S.parts.length ? Math.round(done / S.parts.length * 100) : 0) + "%";
    document.getElementById("bnm-lab").innerHTML = "<span>買えたパーツ <b>" + done + " / " + S.parts.length +
      "</b></span><span>" + (done === S.parts.length ? "すべて購入済み" : "残り " + (S.parts.length - done) + "点") + "</span>";
    var body;
    if (k === "summary") body = summaryHtml();
    else if (k === "part") body = partHtml(S.pg);
    else body = '<div class="step">' + chosenHtml() + finHtml() + "</div>";
    el.innerHTML = body + navHtml() + helpHtml() +
      '<div class="save">進行状況はこの端末に保存されます。ショップのタブから戻ってきたときも、この画面の続きから再開できます。氏名・ご住所は記録していません。</div>';
    var wrap = panel && panel.querySelector(".w"); if (wrap) wrap.scrollTop = 0;
    if (IS_PAGE) { try { window.scrollTo(0, 0); } catch (e) {} }
  }

  /* ---------- 代行プラン ---------- */
  function loadPlans() {
    if (S.plans) return Promise.resolve(S.plans);
    return fetch("/products/" + SERVICE_HANDLE + ".js", { cache: "no-store" }).then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
      if (!p || !p.variants) return null;
      S.plans = p.variants.filter(function (v) { return v.available !== false; }).map(function (v) { return { id: v.id, title: v.title, price: v.price / 100 }; });
      if (S.plans && S.plans[S.planIdx]) S.plan = S.plans[S.planIdx];
      if (document.getElementById("bnm-body")) render();
      return S.plans;
    }).catch(function () { return null; });
  }
  /* カート直リンク。開くとその場でカートに入り、決済画面まで進む。
     行の属性（properties）は直リンクでは渡せないので、注文メモに残る「カート属性」を使う。
     LINEで送ったり、あとで自分で戻ったりできる。 */
  function permalink() {
    if (!S.plan) return "";
    var a = {
      "構成": specText(),
      "パーツ合計（目安）": yen(S.total),
      "パーツ購入の進み具合": S.parts.filter(function (p) { return p.bought; }).length + " / " + S.parts.length + "点 購入済み",
      "申込元": "PCビルダー",
    };
    if (S.id) a["進行状況ID"] = S.id;
    var qs = Object.keys(a).map(function (k) { return "attributes[" + encodeURIComponent(k) + "]=" + encodeURIComponent(a[k]); }).join("&");
    return location.origin + "/cart/" + S.plan.id + ":1?" + qs;
  }
  /* 入力欄の中身をコピーする共通処理 */
  function copyBox(inputId, btnId) {
    var inp = document.getElementById(inputId), btn = document.getElementById(btnId);
    if (!inp || !btn) return;
    var t = btn.textContent;
    var done = function () { btn.textContent = "コピー済 ✓"; setTimeout(function () { btn.textContent = t; }, 2500); };
    try { inp.focus(); inp.setSelectionRange(0, inp.value.length); } catch (e) {}
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(inp.value).then(done).catch(function () { try { document.execCommand("copy"); done(); } catch (e2) {} });
    } else { try { document.execCommand("copy"); done(); } catch (e) {} }
  }
  function copyLink() {
    var inp = document.getElementById("bnm-link"), btn = document.getElementById("bnm-copy");
    if (!inp || !btn) return;
    var done = function () { btn.textContent = "コピー済 ✓"; track("bn_media_copylink", {}); setTimeout(function () { btn.textContent = "コピー"; }, 2500); };
    /* 選択もしておく。コピーが弾かれる環境でも、手で操作すれば取れる */
    try { inp.focus(); inp.setSelectionRange(0, inp.value.length); } catch (e) {}
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(inp.value).then(done).catch(function () { try { document.execCommand("copy"); done(); } catch (e2) {} });
    } else { try { document.execCommand("copy"); done(); } catch (e) {} }
  }

  function order() {
    if (!S.plan || S.busy) return;
    if (S.parts.some(function (p) { return !p.bought; })) return;
    var go = document.getElementById("bnm-go"); S.busy = true; go.disabled = true; go.textContent = "お手続きに進んでいます…";
    var props = {
      "構成": specText(),
      "パーツ合計（目安）": yen(S.total),
      "パーツ購入の進み具合": S.parts.filter(function (p) { return p.bought; }).length + " / " + S.parts.length + "点 購入済み",
      "パーツ発送先": SHIP_TO,
      "申込元": "PCビルダー",
    };
    if (S.id) props["進行状況ID"] = S.id;
    fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items: [{ id: S.plan.id, quantity: 1, properties: props }] }) })
      .then(function (r) { if (!r.ok) throw new Error("cart"); return r.json(); })
      .then(function () {
        track("bn_media_daiko", { plan: S.plan.title, total: Math.round(S.total) });
        if (S.id) { try { navigator.sendBeacon(API + "/plan/ordered", new Blob([JSON.stringify({ id: S.id, note: S.plan.title })], { type: "application/json" })); } catch (e) {} }
        window.location.href = "/checkout";
      })
      .catch(function () {
        S.busy = false; go.disabled = false; go.textContent = "組み立てサポートを購入する";
        document.getElementById("bnm-err").textContent = "カートに入れられませんでした。時間をおいて再度お試しください。";
      });
  }

  /* ---------- 開閉 ---------- */
  var panel = null;
  function build(b) {
    S.parts = [];
    ORDER.forEach(function (k) {
      var p = b[k]; if (!p) return;
      /* ALT: 売り切れの代わりが決まっていれば、そちらで買っていただく */
      if (S.subs && S.subs[k]) p = S.subs[k];
      S.parts.push({ cat: k, name: p.name, disp: displayName(k, p), price: p.price || 0, url: p.url || "", used: isUsed(p.name), bought: false });
    });
    /* OS: ビルダーの構成には価格が入らないので、購入対象として1行足す。
       ストレージが無い構成はOSを入れられないので出さない（ビルダーの表記と揃える） */
    if (S.os && b.ssd && window.BN_OS_ON !== false) {
      S.parts.push({ cat: "os", name: S.os.title, disp: S.os.title, price: S.os.price || 0, url: S.os.url || "", used: false, bought: false, fixed: true });
    }
    S.total = S.parts.reduce(function (a, p) { return a + p.price; }, 0);
    S.planKey = hash(sig());
    /* 構成確認のときに調べた在庫を、同じ構成ならそのまま使う */
    S.stock = (chkSig(b) === CHK.sig) ? CHK.byCat : {};
    S.openCat = "";
    var saved = lsGet();
    S.id = saved && saved.id || null;
    S.mode = saved && saved.mode || "";
    S.planIdx = (saved && saved.planIdx) || 0;
    S.plan = (S.plans || [])[S.planIdx] || null;
    S.awaiting = (saved && saved.awaiting) || "";
    if (saved && saved.bought) S.parts.forEach(function (p) { if (saved.bought.indexOf(p.cat) >= 0) p.bought = true; });
    S.pg = pgResume();/* 前回の続き（まだ買っていない最初のパーツ）から開く */
  }
  /* COMEBACK: 構成が手元に無くても（再読み込み後など）、この端末に残した進行状況で組み直す */
  function restoreState() {
    var k = lsLast(); if (!k) return false;
    var d = lsRead(k);
    if (!d || !d.parts || !d.parts.length) return false;
    S.parts = d.parts.map(function (p) { return { cat: p.cat, name: p.name, disp: p.disp, price: p.price, url: p.url, used: p.used, bought: !!p.bought }; });
    S.total = d.total || S.parts.reduce(function (a2, p2) { return a2 + (p2.price || 0); }, 0);
    S.planKey = k; S.id = d.id || null; S.mode = d.mode || ""; S.planIdx = d.planIdx || 0;
    S.plan = (S.plans || [])[S.planIdx] || null;
    S.pg = (d.pg != null ? d.pg : pgResume()); S.awaiting = d.awaiting || "";
    S.offers = {}; S.stock = {}; S.openCat = ""; S.busy = false;
    return true;
  }
  function open(mode) {
    if (mode === "ready") { /* BUYPAGE: 状態はもう用意できている */ }
    else if (mode === "restored") { if (!restoreState()) return false; }
    else {
      var b = window.BN_CURRENT || null;
      if (!b || !b.cpu) { if (!restoreState()) { alert("先に構成を作ってください（予算と用途を選んで「構成を確認する」）"); return false; } }
      else build(b);
    }
    if (!panel) {
      /* BUYPAGE: 専用ページに置かれた入れ物があればそれを使う。無ければ覆いを作る（従来どおり） */
      panel = document.getElementById("bnm");
      if (panel) { IS_PAGE = true; panel.classList.add("page"); }
      else { panel = document.createElement("div"); panel.id = "bnm"; }
      panel.addEventListener("click", function (e) {
        if (!IS_PAGE && e.target === panel) return close();/* SCROLLFIX: ページ版に「背景を押して閉じる」は無い */
        var x = e.target.closest("#bnm-x"); if (x) return close();
        var w = e.target.closest("[data-mode]");
        if (w) {
          S.mode = w.getAttribute("data-mode");
          var pi = w.getAttribute("data-plan");
          if (pi != null) { S.planIdx = +pi; S.plan = (S.plans || [])[S.planIdx] || null; }
          track("bn_media_mode", { mode: S.mode, plan: S.planIdx });
          /* 選んだらそのまま1つ目のパーツへ（申し込みフォームと同じ進み方）*/
          if (S.pg === 0) { S.pg = 1; pgPush(1); }
          save(); lsSet(); render(); return;
        }
        var gg = e.target.closest("[data-go]");
        if (gg) {
          var gv = gg.getAttribute("data-go");
          if (gv === "close") return close();
          goPg(gv === "next" ? S.pg + 1 : gv === "prev" ? S.pg - 1 : +gv);
          return;
        }
        /* COMEBACK: 戻ってきたときの「買えましたか？」への返事 */
        var cb = e.target.closest("[data-cb]");
        if (cb) {
          var yes = cb.getAttribute("data-cb") === "yes";
          var tp = S.parts.filter(function (x3) { return x3.cat === S.awaiting; })[0];
          S.awaiting = ""; hideBack();
          if (yes && tp) { tp.bought = true; track("bn_media_bought", { cat: tp.cat, via: "comeback" }); }
          save(); lsSet();
          /* 買えた／あとにする、どちらでも次のパーツへ進む */
          if (pgKind(S.pg) === "part") { S.pg = Math.min(S.pg + 1, pgCount() - 1); pgPush(S.pg); }
          render(); return;
        }
        var mo = e.target.closest("[data-more]");
        if (mo) { var c = mo.getAttribute("data-more"); S.openCat = (S.openCat === c ? "" : c); track("bn_media_cands", { cat: c }); render(); return; }
        var sk = e.target.closest("[data-skip]");
        if (sk) {
          /* あとにする＝いったん末尾へ回す。買わずに次のパーツへ進める */
          var c2 = sk.getAttribute("data-skip");
          var idx = S.parts.findIndex(function (x) { return x.cat === c2; });
          if (idx >= 0) { S.parts.push(S.parts.splice(idx, 1)[0]); render(); }
          return;
        }
        var bt = e.target.closest("[data-buy]");
        if (bt) {
          var cat = bt.getAttribute("data-buy");
          var p = S.parts.filter(function (x2) { return x2.cat === cat; })[0];
          if (p) {
            p.bought = !p.bought;
            track(p.bought ? "bn_media_bought" : "bn_media_unbought", { cat: cat });
            S.awaiting = ""; save(); lsSet();
            /* 「買えました」を押したら、そのまま次のパーツのページへ */
            if (p.bought && pgKind(S.pg) === "part" && pgPart(S.pg) === p) { S.pg = Math.min(S.pg + 1, pgCount() - 1); pgPush(S.pg); }
            render();
          }
          return;
        }
        var pl = e.target.closest(".plan");
        if (pl && S.plans) { S.plan = S.plans[+pl.getAttribute("data-i")]; render(); return; }
        if (e.target.closest("#bnm-go")) { order(); return; }
        if (e.target.closest("#bnm-copy")) { copyLink(); return; }
        if (e.target.closest("#bnm-bcopy")) { copyBox("bnm-blink", "bnm-bcopy"); track("bn_media_buylink", {}); return; }
        if (e.target.closest("#bnm-addrcopy")) {
          var ab = document.getElementById("bnm-addrcopy");
          var done2 = function () { ab.textContent = "コピー済 ✓"; setTimeout(function () { ab.textContent = "コピー"; }, 2500); };
          if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(SHIP_TO).then(done2).catch(function () {});
          track("bn_media_addrcopy", {});
          return;
        }
        var a = e.target.closest("a[data-shop]");
        if (a) {
          track("bn_media_shop", { shop: a.getAttribute("data-shop") });
          /* COMEBACK: どのパーツを見に行ったかを覚えておく。戻ったときにそれだけ聞く */
          S.awaiting = a.getAttribute("data-cat") || "";
          lsSet();
          /* RETURN: 押した直後に戻り方を出す。押す前の説明は読まれないため */
          if (a.getAttribute("data-cat")) setTimeout(function () { showBack(); }, 400);
        }
        var rt = e.target.closest("[data-ret]");
        if (rt && rt.getAttribute("data-ret") === "copy") {
          e.preventDefault();
          var u = backUrl();
          var done = function () { rt.textContent = "コピーしました ✓"; setTimeout(function () { rt.textContent = "リンクをコピー"; }, 2500); };
          if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(u).then(done).catch(function () {});
          track("bn_ret_copy", {});
          return;
        }
        if (rt) track("bn_ret_line", {});
        var l = e.target.closest("a[data-path]"); if (l) track("bn_media_self", {});
        var hp = e.target.closest("a[data-help]"); if (hp) track("bn_media_help", { via: hp.getAttribute("data-help"), pg: S.pg });
      });
      if (!panel.parentNode) document.body.appendChild(panel);/* BUYPAGE: 専用ページの入れ物は既にDOMにある */
    }
    panel.innerHTML =
      '<div class="w"><div class="hd"><button class="x" type="button" id="bnm-x" aria-label="閉じる">×</button>' +
      '<h2>この構成のパーツを買う</h2>' +
      '<div id="bnm-steps"></div>' +
      '<div id="bnm-barwrap"><div class="bar"><i id="bnm-fill"></i></div><div class="barlab" id="bnm-lab"></div></div></div>' +
      '<div class="bd" id="bnm-body"></div></div>';
    panel.hidden = false;
    var sp = document.getElementById("bn-stock"); if (sp) sp.hidden = true;
    /* SCROLLFIX(2026-09-06): ページの背後を固定するのは覆い（モーダル）のときだけ。
       専用ページで付けると、ページそのものがスクロールできなくなる。 */
    if (!IS_PAGE) {
      document.documentElement.classList.add("bnm-open");
      document.body.classList.add("bnm-open");
    }
    openFlag(true);
    render();
    track("bn_media_open", { total: Math.round(S.total), how: mode || "build", page: IS_PAGE ? 1 : 0 });
    save(); lsSet();
    loadOffers();
    return true;
  }
  function close() {
    if (!panel) return;
    openFlag(false);
    if (IS_PAGE) { location.href = BUILDER_PATH; return; }
    panel.hidden = true;
    document.documentElement.classList.remove("bnm-open");
    document.body.classList.remove("bnm-open");
  }
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && panel && !panel.hidden) close(); });
  /* RETURN: ショップを開いた直後に、画面の下へ「戻ってきたらここを押す」を出しておく。
     タブを切り替えて戻ったとき、最初に目に入る場所に置く。 */
  function showBack() {
    if (!panel || panel.hidden) return;
    var el = document.getElementById("bnm-back");
    if (!el) {
      el = document.createElement("div");
      el.id = "bnm-back";
      panel.appendChild(el);
    }
    var p = S.awaiting ? S.parts.filter(function (x) { return x.cat === S.awaiting; })[0] : null;
    el.innerHTML = '<b>お店のタブで買い終わったら、この画面に戻ってきてください</b>' +
      (p ? "<span>" + esc(LABEL[p.cat]) + "「" + esc(p.disp) + "」を開いています</span>" : "") +
      '<button type="button" data-cb="yes">買えました</button>' +
      '<button type="button" class="g" data-cb="no">まだです</button>';
    el.hidden = false;
  }
  function hideBack() { var el = document.getElementById("bnm-back"); if (el) el.hidden = true; }

  /* COMEBACK: ショップのタブから戻ってきたら、開いていたパーツの確認を出す */
  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState !== "visible") return;
    if (panel && !panel.hidden && S.awaiting) render();
  });

  /* ---------- 構成ができたら在庫を確認する ----------
     ドスパラの商品ページを見に行くので、1回あたり構成の点数（最大10）だけ。
     同じ構成では二度打たない。Worker側も10分キャッシュ。 */
  var CHK = { sig: "", byCat: {}, busy: false };
  function chkSig(b) { return ORDER.map(function (k) { return b[k] ? (b[k].url || b[k].name) : ""; }).join("|"); }
  function strip() {
    var el = document.getElementById("bn-stock");
    if (!el) {
      el = document.createElement("div"); el.id = "bn-stock"; el.hidden = true;
      el.style.cssText = "position:fixed;left:0;right:0;z-index:9990;font:13px/1.5 inherit;padding:8px 14px;text-align:center;background:#16181d;color:#fff";
      document.body.appendChild(el);
    }
    var bar = document.getElementById("bnbar");
    el.style.bottom = (bar && !bar.hidden ? bar.offsetHeight : 0) + "px";
    return el;
  }
  function showStock(res) {
    var el = strip();
    if (!res) { el.hidden = true; return; }
    if (res === "loading") { el.style.background = "#16181d"; el.innerHTML = "各ショップの在庫を確認しています…"; el.hidden = false; return; }
    var gone = (res.items || []).filter(function (i) { return i.status === "gone"; });
    var pr = (res.items || []).filter(function (i) { return i.status === "price"; });
    if (!gone.length && !pr.length) {
      if (!res.checked) { el.hidden = true; return; }
      el.style.background = "#15803d";
      el.innerHTML = "確認しました。" + res.checked + "点すべて在庫があります";
      setTimeout(function () { el.hidden = true; }, 4000);
      el.hidden = false; return;
    }
    var msg = [];
    if (gone.length) msg.push("<b>" + gone.map(function (i) { return LABEL[i.cat]; }).join("・") + "</b> が売り切れています");
    if (pr.length) msg.push(pr.map(function (i) { return LABEL[i.cat] + " " + yen(i.was) + "→" + yen(i.now); }).join("・"));
    el.style.background = gone.length ? "#b91c1c" : "#b45309";
    /* GUARD(2026-09-06): 売り切れは「構成を確認する」の中で処理し、別の構成に切り替えるようにした。
       ここで後から知らせる必要はなくなったので、価格が変わったときだけ出す。 */
    if (gone.length) { el.hidden = true; return; }
    el.innerHTML = msg.join(" ／ ");
    el.hidden = false;
  }
  /* BUYPAGE: 購入ページでも、開いた時点でドスパラの在庫を見る（10点まで・売り切れを先に知らせる） */
  function checkStockParts() {
    var items = S.parts.filter(function (p) { return !p.bought && /dospara\.co\.jp/.test(p.url || ""); })
      .map(function (p) { return { cat: p.cat, url: p.url, price: p.price || 0 }; });
    if (!items.length) return;
    fetch(API + "/stock/check", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (!j || !j.ok) return;
        (j.items || []).forEach(function (i) { S.stock[i.cat] = i.status; });
        track("bn_stock_check", { gone: j.gone, price: j.price_changed, page: 1 });
        render();
      }).catch(function () {});
  }
  /* ALT(2026-09-06): 売り切れたパーツの代わりを、ビルダーと同じ在庫から1点選ぶ。
     ①まず同じ型番の別個体（中古は一点物なので、同型番の在庫が別にあることが多い）
     ②無ければ同じカテゴリで価格がいちばん近いもの
     見つからなければ null（そのときは従来どおりの案内にする） */
  function findAlt(cat, cur) {
    var all = (window.BN_PARTS && window.BN_PARTS[cat]) || [];
    if (!all.length || !cur) return null;
    var others = all.filter(function (x) { return x.url !== cur.url && x.name !== cur.name; });
    if (!others.length) return null;
    var fmt = window.BN_FMT || {};
    var label = function (x) {
      try {
        if (cat === "cpu" && fmt.cpu) return fmt.cpu(x.name);
        if (cat === "gpu" && fmt.gpu) return fmt.gpu(x.name);
        if (cat === "mem" && fmt.mem) return fmt.mem(x.name, 0);
        if (cat === "ssd" && fmt.ssd) return fmt.ssd(x.name);
      } catch (e) {}
      return String(x.name || "");
    };
    var want = label(cur);
    var same = others.filter(function (x) { return label(x) === want; });
    var pool = same.length ? same : others;
    /* 価格が近い順。同型番があるならその中でいちばん安いもの */
    pool = pool.slice().sort(function (a, b) {
      if (same.length) return a.price - b.price;
      return Math.abs(a.price - cur.price) - Math.abs(b.price - cur.price);
    });
    var pick = pool[0];
    if (!pick) return null;
    return { cat: cat, name: pick.name, price: pick.price, url: pick.url || "", img: pick.img || "", same: same.length > 0 };
  }

  function checkStock() {
    var b = window.BN_CURRENT; if (!b || !b.cpu || CHK.busy) return;
    var s = chkSig(b);
    if (s === CHK.sig) { return; }
    CHK.sig = s; CHK.busy = true; CHK.byCat = {};
    showStock("loading");
    /* AMAZONONLY: 在庫チェックはドスパラの商品ページを見る仕組みなので、ドスパラのURLだけ送る */
    var items = ORDER.filter(function (k) { return b[k] && /dospara\.co\.jp/.test(b[k].url || ""); })
      .map(function (k) { return { cat: k, url: b[k].url || "", price: b[k].price || 0 }; });
    if (!items.length) { CHK.busy = false; showStock(null); return; }
    fetch(API + "/stock/check", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        CHK.busy = false;
        if (!j || !j.ok) { showStock(null); return; }
        (j.items || []).forEach(function (i) { CHK.byCat[i.cat] = i.status; });
        showStock(j);
        track("bn_stock_check", { gone: j.gone, price: j.price_changed });
      })
      .catch(function () { CHK.busy = false; showStock(null); });
  }
  var chkTimer = null;
  window.addEventListener("bn:build", function () { clearTimeout(chkTimer); chkTimer = setTimeout(checkStock, 900); S.subs = {}; });
  /* ALT: 「この候補で進む」→ 差し替えたうえで購入手順を開く */
  document.addEventListener("click", function (e) {
    if (!e.target.closest || !e.target.closest("#bnalt-go")) return;
    e.preventDefault(); e.stopPropagation();
    track("bn_alt_take", { cats: Object.keys(S.subs).join(",") });
    open();
  }, true);

  /* 販売時代の「注文へ進む」は4か所ある。すべて購入パネルへ振り替える。
     #bnbar-cart 追従バー / #ba-cart-btn・.bn__cart-btn 構成カードとAIチャット / #bncf-go 確認シート */
  var BUY_SEL = "#bnbar-cart,#ba-cart-btn,.bn__cart-btn,#bncf-go";
  function relabel(b) {
    if (!b || b.dataset.busy) return;
    var t = "この構成の買い方へ進む";
    b.disabled = false;
    if (b.textContent !== t) b.textContent = t;
  }
  /* BUYPAGE: サーバに預けた構成（/plan?id=）を画面の状態に戻す */
  function applyPlan(j) {
    if (!j || !j.ok || !j.parts || !j.parts.length) return false;
    S.parts = j.parts.map(function (p) { return { cat: p.cat, name: p.name, disp: p.name, price: p.price || 0, url: p.url || "", used: !!p.used, bought: !!p.bought }; });
    S.total = j.total || S.parts.reduce(function (a, p) { return a + (p.price || 0); }, 0);
    S.id = j.id; S.planKey = hash(sig());
    S.mode = (j.mode === "self" || j.mode === "daiko") ? j.mode : "";
    /* この端末に続き（買った印・進め方）が残っていればそちらを優先する */
    var d = lsRead(S.id) || lsRead(S.planKey);
    if (d) {
      if (d.bought) S.parts.forEach(function (p) { if (d.bought.indexOf(p.cat) >= 0) p.bought = true; });
      if (d.mode) S.mode = d.mode;
      S.planIdx = d.planIdx || 0; S.awaiting = d.awaiting || "";
    }
    S.plan = (S.plans || [])[S.planIdx] || null;
    S.pg = (d && d.pg != null) ? d.pg : pgResume();
    return true;
  }
  /* BUYPAGE: 構成が見つからないとき（直接URLを開かれた等） */
  function emptyHtml() {
    return '<div class="w"><div class="hd"><h2>構成が見つかりませんでした</h2></div>' +
      '<div class="bd"><div class="empty"><b>先にビルダーで構成をお作りください</b>' +
      "<span>ご予算と用途を選んでいただくと、いまの在庫から構成を組み立てます。<br>すでに作った構成のリンクをお持ちの場合は、そのリンクを開いてください。</span>" +
      '<a class="btn dark" href="' + esc(BUILDER_PATH) + '">ビルダーで構成を作る</a>' +
      '<div style="height:8px"></div>' +
      '<a class="btn line" href="' + esc(LINE_URL) + '" target="_blank" rel="noopener" data-help="line">LINEで相談する</a>' +
      "</div></div></div>";
  }
  function bootBuyPage(el) {
    IS_PAGE = true;
    el.classList.add("page");
    el.hidden = false;
    el.innerHTML = '<div class="w"><div class="bd"><div class="empty"><b>構成を読み込んでいます…</b></div></div></div>';
    var id = "";
    try { id = new URLSearchParams(location.search).get("id") || ""; } catch (e) {}
    var show = function (ok) {
      if (!ok) { el.innerHTML = emptyHtml(); return; }
      open("ready");
      /* PGURL: URLで指定されたパーツのページを開く（進め方が未選択なら全体から） */
      var q = pgFromUrl();
      if (q != null && q >= 0 && q <= pgCount() - 1 && (q === 0 || S.mode)) { S.pg = q; render(); }
      pgReplace(S.pg);
      checkStockParts();
    };
    if (id) {
      fetch(API + "/plan?id=" + encodeURIComponent(id), { cache: "no-store" })
        .then(function (r) { return r.json(); })
        .then(function (j) { show(applyPlan(j) || restoreState()); })
        .catch(function () { show(restoreState()); });
    } else { show(restoreState()); }
  }
  /* BUYPAGE: ビルダー側は、構成を預けてから購入ページへ移る */
  function goBuy(btn) {
    var b = window.BN_CURRENT || null;
    if (!b || !b.cpu) { alert("先に構成を作ってください（予算と用途を選んで「構成を確認する」）"); return; }
    build(b); lsSet();
    track("bn_media_gobuy", { total: Math.round(S.total) });
    if (btn) { btn.dataset.busy = "1"; btn.disabled = true; btn.textContent = "購入ページを準備しています…"; }
    saveNow().then(function () { location.href = BUY_PATH + (S.id ? "?id=" + encodeURIComponent(S.id) : ""); });
  }
  function boot() {
    /* BUYPAGE: 専用ページに置かれた入れ物があれば、そちらで手順を出す */
    var host = document.getElementById("bnm");
    if (host) { loadPlans(); loadOs().then(function () { bootBuyPage(host); }); return; }
    /* 取りこぼさないよう、documentのキャプチャ段階で受ける（後から作られるカードにも効く） */
    /* SELLBACK(2026-09-06): 「注文へ進む」は本体の決済（pasotsuku-checkout-v3）に戻したので横取りしない。
       自分でパーツを買いたい人だけが押す専用ボタンから開く。 */
    document.addEventListener("click", function (e) {
      var b = e.target.closest && e.target.closest("#bn-selfbuy");
      if (!b) return;
      e.stopImmediatePropagation(); e.preventDefault();
      var cf = document.getElementById("bncf") || document.querySelector(".bncf");
      if (cf && !cf.hidden) { try { cf.hidden = true; document.body.style.overflow = ""; } catch (x) {} }
      goBuy(b);
    }, true);
    /* SELLBACK: 決済ボタンの文言は本体のまま（「注文へ進む」）にする */
    loadPlans();
    loadOs();
    /* COMEBACK: 買い物の途中でこのページが読み込み直されても、続きの画面から再開する */
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
})();
